var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.formItem.field["dsfa_mm.controls"].value === "dsf.uploadphoto" &&
      _vm.formItem.field_property_value !== "0"
        ? _c(
            "div",
            { staticClass: "uploader-photo" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  staticStyle: {
                    "text-align": "center",
                    "line-height": "10px",
                  },
                  attrs: {
                    action: "/file/upload/",
                    "show-file-list": false,
                    "on-success": _vm.handleAvatarSuccess,
                    multiple: false,
                    "before-upload": _vm.beforeAvatarUpload,
                  },
                },
                [
                  _vm.imageUrl
                    ? _c("div", { staticClass: "user-photo-cont" }, [
                        _c("img", {
                          staticClass: "avatar",
                          attrs: { src: _vm.imageUrl },
                        }),
                        _c("div", { staticClass: "delete-img" }, [
                          _c("i", {
                            staticClass: "iconfont icon-shanchu",
                            on: {
                              "!click": function ($event) {
                                return _vm.handleRemove.apply(null, arguments)
                              },
                            },
                          }),
                        ]),
                      ])
                    : _c("div", { staticClass: "user-photo-cont" }, [
                        _c("i", { staticClass: "el-icon-plus" }, [
                          _vm._v(_vm._s(_vm.formItem.fields_text) + "上传"),
                        ]),
                      ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.field["dsfa_mm.controls"].value === "dsf.textbox" &&
      _vm.formItem.field_property_value !== "0"
        ? _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.formItem.fields_text,
                prop: _vm.formItem.fields_value,
                rules: _vm.rules,
              },
            },
            [
              _c("el-input", {
                class: {
                  "user-input-short": _vm.isShort,
                },
                on: {
                  blur: function ($event) {
                    return _vm.$emit(
                      "set-value",
                      _vm.formItem.fields_value,
                      _vm.modelvalueCopy
                    )
                  },
                },
                model: {
                  value: _vm.modelvalueCopy,
                  callback: function ($$v) {
                    _vm.modelvalueCopy = $$v
                  },
                  expression: "modelvalueCopy",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.field["dsfa_mm.controls"].value === "dsf.datepicker" &&
      _vm.formItem.field_property_value !== "0"
        ? _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.formItem.fields_text,
                prop: _vm.formItem.fields_value,
                rules: _vm.rules,
              },
            },
            [
              _c("el-date-picker", {
                class: {
                  "user-input-short": _vm.isShort,
                },
                staticStyle: { width: "100%" },
                attrs: {
                  type: "date",
                  format: "yyyy 年 MM 月 dd 日",
                  "picker-options": _vm.pickerOptions,
                  "value-format": "yyyy-MM-dd",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit(
                      "set-value",
                      _vm.formItem.fields_value,
                      _vm.currentDate
                    )
                  },
                },
                model: {
                  value: _vm.currentDate,
                  callback: function ($$v) {
                    _vm.currentDate = $$v
                  },
                  expression: "currentDate",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.field["dsfa_mm.controls"].value === "dsf.radiobox" &&
      _vm.formItem.fields_value === "sex" &&
      _vm.formItem.field_property_value !== "0"
        ? _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.formItem.fields_text,
                prop: _vm.formItem.fields_value,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  class: {
                    "user-input-short": _vm.isShort,
                  },
                  on: { change: _vm.changeSex },
                  model: {
                    value: _vm.radioValue,
                    callback: function ($$v) {
                      _vm.radioValue = $$v
                    },
                    expression: "radioValue",
                  },
                },
                _vm._l(_vm.radioOption, function (item) {
                  return _c(
                    "el-radio",
                    { key: item.text, attrs: { label: item } },
                    [_vm._v(_vm._s(item.text))]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.field["dsfa_mm.controls"].value === "dsf.select" &&
      _vm.formItem.field_property_value !== "0"
        ? _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.formItem.fields_text,
                prop: _vm.formItem.fields_value,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-select",
                {
                  class: {
                    "user-input-short": _vm.isShort,
                  },
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.modelvalueCopy,
                    callback: function ($$v) {
                      _vm.modelvalueCopy = $$v
                    },
                    expression: "modelvalueCopy",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "option1", value: "option1" },
                  }),
                  _c("el-option", {
                    attrs: { label: "option2", value: "option2" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }